module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "editCate",
    staticClass: "container",
    attrs: {
      "id": "editCate"
    }
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6 col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_vm._m(0), _c('form', {
    attrs: {
      "action": "#",
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "id": "alert_id",
      "hidden": "hidden"
    }
  }, [(_vm.error) ? _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]), _c('div', {
    staticClass: "form-group",
    class: _vm.errorArray
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label text-md-right",
    staticStyle: {
      "text-align": "left",
      "font": "Regular 15px/22px Proxima Nova",
      "letter-spacing": "0px",
      "color": "#333333",
      "opacity": "1",
      "margin-bottom": "10px"
    },
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Nhập tên danh mục bạn muốn thêm")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "name": "title",
      "required": "required",
      "autofocus": "autofocus",
      "placeholder": "Nhập"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12 offset-md-12",
    staticStyle: {
      "justify-content": "center",
      "display": "flex"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background": "#FFD311 0% 0% no-repeat padding-box",
      "border-radius": "5px",
      "opacity": "1",
      "width": "160px",
      "color": "#23180A",
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitForm($event)
      }
    }
  }, [_vm._v("Thêm mới")]), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background": "#FFFFFF 0% 0% no-repeat padding-box",
      "border": "1px solid #FFD311",
      "border-radius": "5px",
      "opacity": "1",
      "width": "160px",
      "color": "#23180A"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Hủy yêu cầu")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "left",
      "font": "Regular 17px/20px Helvetica",
      "letter-spacing": "0px",
      "color": "#343A40",
      "opacity": "1",
      "border-bottom": "1px solid",
      "padding-bottom": "10px",
      "font-weight": "bold",
      "padding-top": "10px"
    }
  }, [_vm._v("THÊM DANH MỤC BÀI HỌC")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f071946","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Category/cateForm.vue
// module id = 1525
// module chunks = 0